import React from 'react'

const MASKED_VALUE = Array(40).fill('*').join('')

type Props = {
  /** The webhook secret to display (base64 encoded string) */
  secret?: string | null
  /** Whether the secret should be masked */
  isMasked?: boolean
  /** Whether the secret is currently being loaded */
  isLoading?: boolean
}

/** Component for displaying a webhook secret value. */
export default function WebhookSecretDisplay({
  secret,
  isMasked = true,
  isLoading = false,
}: Props) {
  if (isLoading) {
    return (
      <div
        title="Secret pending creation"
        data-testid="secretLoadingSkeleton"
        className="bg-background-surface-secondary h-5 w-3/5 animate-pulse rounded"
      />
    )
  }

  if (!secret) {
    return null
  }

  const displayedValue = isMasked ? MASKED_VALUE : secret

  return (
    <p
      className="text-foreground-subtle break-all font-mono text-sm leading-5"
      data-testid="secretValue"
    >
      {displayedValue}
    </p>
  )
}
